import { IBarcode } from "../interfaces/Barcode";
import { C128 } from "./barcodeUtils";

export const defaultBarcode: IBarcode = {
    X: 0,
    Y: 0,
    Name: "LL_AI_02",
    Width: 50,
    Height: 25,
    ShowCaption: 0,
    CaptionSize: 12,
    Rotation: 0,
    Type: C128,
    DefaultText: "",
    DataMatrixSize: "",
}
